import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const Qwentro = definePreset(Aura, {
  semantic: {
    primary: {
      primary: {
        50: '#ECFDF5',
        100: '#D1FAE5',
        200: '#A7F3D0',
        300: '#6EE7B7',
        400: '#34D399',
        500: '#14A17E',
        600: '#0F7B63',
        700: '#0B5E4C',
        800: '#074A3B',
        900: '#053B2F',
        950: '#0F2B26',
      },
    },
    colorScheme: {
      light: {
        primary: {
          color: '{blue.500}',
          inverseColor: '#ffffff',
          hoverColor: '{blue.900}',
          activeColor: '{blue.800}',
        },
        highlight: {
          background: '{blue.950}',
          focusBackground: '{blue.700}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        surface: {
          0: '#ffffff',
          50: '{zinc.50}',
          100: '{zinc.100}',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '{zinc.700}',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}',
        },
      },
      dark: {
        primary: {
          color: '{blue.50}',
          inverseColor: '{blue.950}',
          hoverColor: '{blue.100}',
          activeColor: '{blue.200}',
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '0.75rem',
      },
    },
    select: {
      root: {
        borderRadius: '0.75rem',
      },
    },
    card: {
      root: {
        borderRadius: '0.75rem',
        shadow: 'none',
      },
    },
    accordion: {
      panel: {
        borderWidth: '1px',
      },
      colorScheme: {
        light: {
          panel: {
            borderColor: '{surface.200}',
          },
        },
        dark: {
          panel: {
            borderColor: '{surface.700}',
          },
        },
      },
    },
    selectbutton: {
      root: {
        borderRadius: '0.5rem',
      },
    },
    togglebutton: {
      root: {
        borderRadius: '0.375rem',
        padding: '0.375rem 0.5rem',
      },
      colorScheme: {
        light: {
          root: {
            background: 'transparent',
            checkedBackground: 'transparent',
            hoverBackground: '{surface.200}',
            borderColor: 'transparent',
            color: '{surface.600}',
            hoverColor: '{surface.900}',
            checkedColor: '{primary.600}',
            checkedBorderColor: 'transparent',
          },
          content: {
            checkedBackground: '{surface.0}',
            checkedShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          },
        },
        dark: {
          root: {
            background: 'transparent',
            checkedBackground: 'transparent',
            hoverBackground: '{surface.800}',
            borderColor: 'transparent',
            color: '{surface.400}',
            hoverColor: '{surface.100}',
            checkedColor: '{primary.400}',
            checkedBorderColor: 'transparent',
          },
          content: {
            checkedBackground: '{surface.800}',
            checkedShadow: '0 4px 6px -1px rgb(0 0 0 / 0.3)',
          },
        },
      },
    },
  },
});
